<base-site-layout
    [heading]="'Ansprechpartner wechseln' | translate"
    headerIcon="fas fa-user-pen"
    [isDialog]="true"
    (dialogCloseClicked)="cancel()"
>
    <div class="px-3">
        <div class="row mb-2">
            <div class="col">
                <strong>{{ data.companyName }}</strong>
            </div>
        </div>

        @if (loading()) {
            <div class="row mb-3">
                <div class="col text-center">
                    <em class="fas fa-spinner fa-spin pe-2"></em>
                    {{ 'Ansprechpartner werden geladen' | translate }}
                </div>
            </div>
        } @else if (contacts().length === 0) {
            <div class="row mb-3">
                <div class="col">
                    <div class="alert alert-info mb-0">
                        {{ 'Für diesen Lieferanten sind keine Ansprechpartner hinterlegt' | translate }}
                    </div>
                </div>
            </div>
        } @else if (singleContact(); as contact) {
            <div class="row mb-3">
                <div class="col">
                    <div class="alert alert-info mb-0">
                        {{ 'Dieser Lieferant hat nur einen Ansprechpartner:' | translate }}
                        <strong>
                            {{ contact.person | person | supplierContactName: contact.defaultContact }}
                        </strong>
                        @if (contact.person.id === standardContactId()) {
                            <em
                                class="fa-solid fa-star text-primary ms-1"
                                data-cy="STANDARD_CONTACT_STAR"
                                [matTooltip]="'Standard für diesen Buchungskreis' | translate"
                            ></em>
                        }
                    </div>
                </div>
            </div>
        } @else {
            <form [formGroup]="form">
                <div class="row mb-3">
                    <div class="col d-flex flex-column">
                        <label id="changeContactLabel">{{ 'Ansprechpartner' | translate }}</label>
                        <mat-radio-group
                            class="d-flex flex-column"
                            formControlName="contactId"
                            aria-labelledby="changeContactLabel"
                            data-cy="CHANGE_SUPPLIER_CONTACT_OPTIONS"
                        >
                            @for (contact of contacts(); track contact.person.id) {
                                <mat-radio-button [value]="contact.person.id">
                                    {{ contact.person | person | supplierContactName: contact.defaultContact }}
                                    @if (contact.person.id === standardContactId()) {
                                        <em
                                            class="fa-solid fa-star text-primary ms-1"
                                            data-cy="STANDARD_CONTACT_STAR"
                                            [matTooltip]="'Standard für diesen Buchungskreis' | translate"
                                        ></em>
                                    }
                                </mat-radio-button>
                            }
                        </mat-radio-group>
                    </div>
                </div>
            </form>
        }

        <div class="row justify-content-end">
            <div class="col-auto mb-2">
                <div class="btn-group btn-group-sm">
                    <button type="button" class="btn btn-secondary" (click)="cancel()">
                        {{ 'Abbrechen' | translate }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        (click)="save()"
                        [disabled]="form.invalid || form.controls.contactId.value === data.currentContactId"
                    >
                        {{ 'Übernehmen' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</base-site-layout>
